/* eslint-disable class-methods-use-this */
/* eslint-disable max-classes-per-file */

import { RequestBase } from '../requestBase';
import { APIRoutes } from '../apiRoutes';
import { CatalogOrderFileRoot } from '../../fileFormats/catalogOrder/catalogOrder';

export class RequestOrderVerificationCode extends RequestBase {
  public override getAPIEndPoint(): string {
    return APIRoutes.Orders_VerificationCode;
  }

  public sessionToken: string | undefined;
  public orderData: CatalogOrderFileRoot | undefined;
  public language: string | undefined;
}

export class ResponseOrderVerificationCode {
  public verificationCode = '123456';
  public result = false;
}
